import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-bayesian-inference',
  templateUrl: './bayesian-inference.component.html',
  styleUrls: ['./bayesian-inference.component.scss']
})
export class BayesianInferenceComponent implements OnInit {

  exposition: CardContent = {
    title: 'Bayesian Inference',
    subtitle: 'Bayesian Inference using Gibbs Sampling',
    image_source: 'assets/images/PASIplot2.png',
  };

  constructor() { }

  ngOnInit(): void {
  }

}
